import LandingPage, { getStaticProps as getLandingStaticProps } from './home';
export default LandingPage;
export const getStaticProps = getLandingStaticProps;